import UploadImageField, { UploadImageFieldProps } from './UploadImageField';

export type { UploadImageFieldProps };
export default UploadImageField;
